import { windowBreakpoints } from "../app.settings";
//import { useMediaQuery } from 'react-responsive'

export enum EDeviceType {
    MOBILE = "MOBILE",
    TABLET = "TABLET",
    DESKTOP = "DESKTOP",
}

export const getDeviceType = (): EDeviceType => {
    /*
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
      })
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
    */
    
    const { innerWidth } = window;
    if (innerWidth < windowBreakpoints.tablet) return EDeviceType.MOBILE;
    if (innerWidth < windowBreakpoints.desktop) return EDeviceType.TABLET;
    return EDeviceType.DESKTOP;
};

export const detectMobile = (device: EDeviceType): boolean => device === EDeviceType.MOBILE;

export const detectDesktop = (device: EDeviceType): boolean => device === EDeviceType.DESKTOP;

export const detectTablet = (device: EDeviceType): boolean => device === EDeviceType.TABLET;
